import { Button, Card, Flex, Heading, Text, useTheme, View } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import './LegalNoticePopup.css';

interface LegalNoticePopupProps {
    handleCloseOverlay: () => void;
}

export default function LegalNoticePopup({ handleCloseOverlay }: LegalNoticePopupProps) {
    const { t } = useTranslation();
    const { tokens } = useTheme();

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                handleCloseOverlay();
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleCloseOverlay]);

    return (
        <View className="legal-notice-overlay-content"
            backgroundColor={tokens.colors.background.secondary}
            padding={tokens.space.medium}
        >
            <Card className="legal-notice-card">
                <Button
                    variation="link"
                    size="large"
                    onClick={handleCloseOverlay}
                    className="legal-notice-close-button"
                >
                    &times;
                </Button>
                
                <Flex direction="column" gap={tokens.space.medium}>
                    <Heading level={2} className="legal-notice-title">
                        {t('legal-notice.title')}
                    </Heading>
                    
                    <div className="legal-notice-content">
                        <div className="legal-notice-section">
                            <Heading level={3} className="legal-notice-section-title">
                                {t('legal-notice.beta-notice')}
                            </Heading>
                            <Text className="legal-notice-text">
                                {t('legal-notice.beta-text')}
                            </Text>
                        </div>

                        <div className="legal-notice-section">
                            <Heading level={3} className="legal-notice-section-title">
                                {t('legal-notice.data-security')}
                            </Heading>
                            <Text className="legal-notice-text">
                                {t('legal-notice.data-security-text')}
                            </Text>
                        </div>

                        <div className="legal-notice-section">
                            <Heading level={3} className="legal-notice-section-title">
                                {t('legal-notice.data-usage')}
                            </Heading>
                            <Text className="legal-notice-text">
                                {t('legal-notice.data-usage-text')}
                            </Text>
                        </div>

                        <div className="legal-notice-section">
                            <Heading level={3} className="legal-notice-section-title">
                                {t('legal-notice.future-policy')}
                            </Heading>
                            <Text className="legal-notice-text">
                                {t('legal-notice.future-policy-text')}
                            </Text>
                        </div>
                    </div>

                    <Flex justifyContent="center" marginTop={tokens.space.large}>
                        <Button
                            variation="primary"
                            onClick={handleCloseOverlay}
                            className="legal-notice-close-button-main"
                        >
                            {t('legal-notice.close')}
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </View>
    );
}
